export const AUTH_SIGN_MESSAGE = 'Action: Connect Acorn Points to a Wallet'
